import { CoordinatorService } from "./coordinator.service"
import { Report$ } from "./report$"

export class ReportField {
    coords: CoordinatorService


    constructor(private parent: Report$,
        public tag: string,
        public inSummary = false
    ) {
        this.coords = this.parent.coords
        this.parent.fieldMap.set(this.tag, this)

    }

    get title() {
        return this.coords.text(`report-${this.tag}`)
    }

    // get value() {
    //     switch (this.tag) {
    //         case "mainSize":
    //             return this.coords.dataset$
    //                 .main.size$.getValue.toString()
    //     }
    //     return ""
    // }

    switchSummary() {
        this.inSummary = !this.inSummary
    }

}
